import { CircleCheck } from "lucide-react";
import { H2 } from "../headers";
import { Button } from "../ui/button";
import { useTranslations } from "next-intl";
import Link from "next/link";

const FinalStep = () => {
  const t = useTranslations();

  return (
    <div className="flex flex-col items-center gap-10 flex-1 text-center max-sm: justify-center">
      <CircleCheck className="fill-green-main text-white size-24 sm:size-36" />
      <H2>{t("finalStepSection.thankYou")}</H2>
      <p className="text-gray-light font-light text-lg">
        {t("finalStepSection.startExploring")}
      </p>
      <Button className="max-w-64 w-full" asChild>
        <Link href={"/all-units"} prefetch>
          {t("finalStepSection.startSearch")}
        </Link>
      </Button>
    </div>
  );
};

export default FinalStep;
